import { FC } from 'react'
import { UserProfile } from 'components/User'
import RestrictedForDesktop from 'components/RestrictedForDesktop'
import { UserProtectedRoute } from 'routes'

const UserPage: FC = () => {
  return (
    <UserProtectedRoute>
      <RestrictedForDesktop redirectTo='/user/account'>
        <UserProfile />
      </RestrictedForDesktop>
    </UserProtectedRoute>
  )
}

export default UserPage
